<ion-app>
  <ion-router-outlet [animation]="pageTransition"></ion-router-outlet>
</ion-app>
